import React from 'react'

import Layout from 'components/shared/Layout'
import Tetris from 'components/decorations/Tetris'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const GradientHeader = ({
  className,
  footer,
  gradientPosition,
  wrapperClassName,
  children,
  decorationType,
  theme,
  fullWidth,
  wrapperType = 'mobileInnerWrapper',
}) => {
  const wrapper = (children) =>
    fullWidth ? (
      <Layout className={css.subWrapper} type="wrapper">
        {children}
      </Layout>
    ) : (
      children
    )
  
return (
  <Layout
    tag="section"
    className={cx(css.gradient, className, `gradient-${gradientPosition}`, {
        footer,
        fullWidth,
      })}
  >
    <Layout type="wrapper" className={cx(css.wrapper, wrapperClassName)}>
      {wrapper(
        <>
          <Layout type={wrapperType}>{children}</Layout>
          {decorationType && !fullWidth && (
          <Tetris
            className={css.decoration}
            theme={theme}
            type={decorationType}
          />
            )}
        </>
        )}
    </Layout>
  </Layout>
  )
}

GradientHeader.defaultProps = {
  gradientPosition: 'right',
}

export default GradientHeader
